import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useMe } from '@/api/hooks/useMe'
import { useUsersByWorkshop } from '@/api/hooks/useUsersByWorkshop'
import PageLayout from '@/components/layout/page-layout'
import { StaffSchedule } from '@/components/organisms/staff-schedule'
import { useAppSelector } from '@/redux/hooks'

export const Route = createFileRoute('/_authenticated/schedule')({
  component: SchedulePage,
})

function SchedulePage() {
  const { t } = useTranslation()
  const activeWorkshopId = useAppSelector(state => state.settings.activeWorkshopId)
  const { data: user } = useMe()
  const { data: users = [] } = useUsersByWorkshop(activeWorkshopId, { enabled: !!user?.id })

  if (!activeWorkshopId) return null

  return (
    <>
      <PageLayout title={t('schedulePage.title')}>
        <StaffSchedule workshopId={activeWorkshopId} users={users} />
      </PageLayout>
      <Outlet />
    </>
  )
}
